<template>
  <div class="contact-page pt-4 pb-4">
    <div class="container ">          
      <div class="row">
        <div class="col-xs-12 contact-detail">
            <h4></h4>
            <ul style="padding-left: 15px;">
              <li class="company"><h1>CÔNG TY TNHH ĐẦU TƯ THƯƠNG MẠI BẢO GIA PHÚ</h1></li>
              <li>
                <i class="fa fa-home"></i>
                <span>	Địa chỉ: 1331/15/69 Lê Đức Thọ, P. 14, Q. Gò Vấp, Tp. Hồ Chí Minh</span >
              </li>
              <li>
                <i class="fa fa-phone"></i>   Hotline:
                <a href="#" class="contact-info"> 09 1889 4567</a>
              </li>
              <li>
                <i class="fa fa-envelope"></i> Email:
                <a href="kinhdoanhocvit@gmail.com">kinhdoanhocvit@gmail.com</a>
              </li>
              <li>
                <i class="fa fa-globe"></i>   Website: <a href="http://thanhren.vn">thanhren.vn</a>
              </li>
            </ul>
        </div>    
        <div class="contact_form_input col-log-6 col-md-6 col-xs-12">
          <div class="contact_form">
            <form
              id="contact_form"
              @submit="checkForm"
              enctype="multipart/form-data"
              novalidate="true"
            >
              <div style="color: red" v-if="isSendMail">Gửi email thành công</div>
              <div id="infoColumn">
                <table style="width: 100%;">
                  <tbody style="width: 100%;">
                    <tr>
                      <td style="padding-top: 10px;" align="left">
                        <strong class="Internal">* Email:&nbsp;</strong>
                        <i style="color: red" v-if="errors">{{ errors[0] }}</i>
                      </td>
                    </tr>
                    <tr style="width: 100%;">
                      <td style="width: 100%;">
                        <input
                          id="email"
                          type="email"
                          name="email"
                          v-model="email"
                          style="width: 100%;"
                          class="form-control"
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="width: 100%;">
                  <tbody style="width: 100%;">
                    <tr style="width: 100%;">
                      <td style="padding-top: 10px;" align="left">
                        <strong class="Internal">* Tiêu đề:&nbsp;</strong>
                        <i style="color: red" v-if="errors">{{ errors[1] }}</i>
                      </td>
                    </tr>
                    <tr style="width: 100%;">
                      <td style="width: 100%;">
                        <input
                          type="text"
                          id="title"
                          name="title"
                          v-model="title"
                          style="width: 100%;"
                          class="form-control"
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table style="width: 100%;">
                  <tbody style="width: 100%;">
                    <tr style="width: 100%;">
                      <td style="padding-top: 10px;" align="left">
                        <strong class="Internal">* Nội dung:&nbsp;</strong>
                        <i style="color: red" v-if="errors">{{ errors[2] }}</i>
                      </td>
                    </tr>
                    <tr style="width: 100%;">
                      <td style="width: 100%;">
                        <textarea
                          id="detail"
                          name="detail"
                          v-model="detail"
                          style="width: 100%; height:250px;"
                          class="form-control"
                          rows="15"
                        ></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div style="margin: 10px; text-align: left;">
                  <a
                    v-on:click="checkForm()"
                    href="javascript:void(0);"
                    id="btn_send"
                    class="btn btn-primary"
                  >Gửi</a> &nbsp;&nbsp;
                  <a
                    v-on:click="resetForm()"
                    href="javascript:void(0);"
                    id="btn_cancel"
                    class="btn"
                  >Nhập lại</a>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class=" col-log-6 col-md-6 col-xs-12">    
          <div id="id-maps" style="overflow: hidden;">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3294.963885537071!2d106.6472616301565!3d10.857569897337797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752994d2ae6b5b%3A0xb84e17a08ae5e5b3!2zUCwgMTMzMS8xNS8zMjggTMOqIMSQ4bupYyBUaOG7jSwgcGjGsOG7nW5nIDE0LCBHw7IgVuG6pXAsIEjhu5MgQ2jDrSBNaW5oLCBWaeG7h3QgTmFt!5e0!3m2!1svi!2s!4v1567422809840!5m2!1svi!2s" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import ApiService from "@/common/api.service";

export default {
  name: "RwvContact",
  components: {},
  computed: {},
  props: {
    errors: [],
    email: null,
    title: null,
    detail: null,
    isSendMail: false
  },
  methods: {
    checkForm: function(e) {
      this.errors = [];
      var valid = true;
      if (!this.email) {
        this.errors.push("Vui lòng nhập email");
        valid = false;
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Sai định dạng email");
        valid = false;
      } else {
        this.errors.push("");
      }

      if (!this.title) {
        this.errors.push("Vui lòng nhập tiêu đề");
        valid = false;
      } else {
        this.errors.push("");
      }

      if (!this.detail) {
        this.errors.push("Vui lòng nhập nội dung");
        valid = false;
      } else {
        this.errors.push("");
      }

      if (valid) {
        this.sendMail();
        this.resetForm();
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sendMail: function() {
      var params = {
        email: this.email,
        title: this.title,
        detail: this.detail
      };
      ApiService.post("api/app/Contact/SendMail", params).then(result => {
        if (result.data.result) {
          this.resetForm();
          this.isSendMail = true;
        }
      });
    },
    resetForm: function() {
      this.isSendMail = false;
      this.email = "";
      this.title = "";
      this.detail = "";
    }
  }
};
</script>

<style>
.contact-detail {
    font-size: 18px;
    line-height: 32px;
    font-weight: 100;
    margin-bottom: 20px;
}
.contact-detail .company h1{
    font-size: 26px;
    color: #1b5084;
    text-transform: uppercase;
    font-weight: 600;
}
.contact_form_input {margin-bottom:20px}
</style>